import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { VariableBenefitConfigurationPaymentFormGroup } from '../../form-groups/variable-benefit-configuration-payment-form-group';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';
import { DropDownItem } from '../../../../../../models/shared/stylesheet/drop-down-item';
import * as moment from 'moment';

@Component({
  selector: 'app-vb-recurring-payments-frequency-form-grid',
  templateUrl: './vb-recurring-payments-frequency-form-grid.component.html',
  styleUrls: ['./vb-recurring-payments-frequency-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbRecurringPaymentsFrequencyFormGridComponent implements OnInit {
  @Input({ required: true }) form!: VariableBenefitConfigurationPaymentFormGroup;
  @Input() displayError = false;

  @Input() isBoardDirected: boolean | null = false;
  @Input({ required: true })
  set effectiveDate(value: string | null) {
    this._effectiveDate.next(value);
  }

  private _effectiveDate = new BehaviorSubject<string | null>(null);

  public yearDropdowns$!: Observable<DropDownItem[]>;

  public monthDropdowns = Array.from(
    { length: 12 },
    (_, i) => new DropDownItem(moment().month(i).format('MMMM'), i + 1)
  );

  public customErrorMessages = {
    paymentStartMonth: {
      recurringPaymentStartBeforeEffectiveDate: $localize`The payment date can not precede the account's effective date`,
      recurringPaymentStartPastCutoff: $localize`Select a date that complies with the cut-off date`,
      recurringPaymentStartAfterMaxYear: $localize`Select a start date no later than next year`
    }
  };

  public ngOnInit(): void {
    this.yearDropdowns$ = this._effectiveDate.pipe(map(d => this.computeYears(d)));
  }

  private computeYears(effectiveDate: string | null): DropDownItem[] {
    const currentYear = moment().year();
    const nextYear = currentYear + 1;
    const effectiveYear = effectiveDate ? moment(effectiveDate).year() : currentYear;
    return [currentYear, nextYear]
      .filter(year => year >= effectiveYear)
      .map(year => new DropDownItem(year.toString(), year));
  }

  protected readonly VariableBenefitPaymentFrequencyEnum = VariableBenefitPaymentFrequencyEnum;
}
